export abstract class Provider {
    protected ean: string;

    constructor(ean: string) {
        this.ean = ean;
    }

    public abstract getAvailabilitySource(): string;

    public abstract isContentAvailable(parsedAvailabilityResponse: Record<string, string>): boolean;

    public abstract createIframeSrc(parsedAvailabilityResponse: Record<string, string>): string;
}
